// Every signal goes to TelemetryDeck's web ingest endpoint (/v2/w/), the same one the
// official Web SDK posts to. That endpoint enriches signals server-side with country,
// browser, platform, device and referrer/UTM data, and derives one anonymous clientUser
// and sessionID per visitor from the request itself -- so page views and interaction
// events share a single identity.
//
// The generic app endpoint (/v2/) used by @telemetrydeck/sdk does none of that, which is
// why it is not used here. Note that sending a custom "type" through the web endpoint
// works but is not documented; if TelemetryDeck ever stops honouring it these events
// would fall back to being recorded as page views.

const APP_ID = "80CF7FD0-1121-4982-830E-6DB0848BE292";
const API = "https://nom.telemetrydeck.com/v2/w/";
const CLIENT_VERSION = "WebSDK 1.1.0";

// Mirrors the Web SDK: localhost and file:// never pollute production numbers.
const isTestMode = () => {
    const { hostname, protocol } = window.location;
    return /^localhost$|^127(\.\d+){0,2}\.\d+$|^\[::1?]$/.test(hostname) || protocol === "file:";
};

function send(body) {
    if (isTestMode()) {
        body.isTestMode = true;
    }

    return fetch(API, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    }).catch(() => {
        // An ad blocker or an offline visitor must never break the page.
    });
}

// The endpoint derives host/path/scheme from the url, so it is passed in explicitly:
// on a route change React Router has already updated the address bar, but on the very
// first render it has not.
export function signalPageView(url) {
    return send({
        appID: APP_ID,
        url,
        referrer: document.referrer,
        telemetryClientVersion: CLIENT_VERSION,
        locale: navigator.language,
    });
}

export function signal(type, payload) {
    return send({
        appID: APP_ID,
        type,
        url: window.location.href,
        referrer: document.referrer,
        telemetryClientVersion: CLIENT_VERSION,
        locale: navigator.language,
        ...(payload ? { payload } : {}),
    });
}
